import React from 'react';
import { SpeakerHigh } from 'phosphor-react';

const WordAnalysis = ({
  wordDetails,
  textToRead,
  onPlayFullSentence,
  onPlayWord,
  isPlayingFullSentence,
  isLoadingFullSentence = false,
  playingWordIndex,
  loadingWordIndex = null,
}) => {
  const playBtnBase =
    'p-2.5 rounded-[10px] bg-gradient-to-br from-[#12766d] to-[#0f5d56] text-white cursor-pointer flex items-center justify-center transition-all duration-300 shadow-[0_2px_8px_rgba(18,118,109,0.2)] shrink-0 hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(18,118,109,0.3)] max-md:w-full max-md:min-h-[44px] max-md:justify-center max-md:py-3';
  const playBtnLoading = 'cursor-progress opacity-90';

  return (
    <div className="rounded-2xl p-5 border-2 bg-gradient-to-br from-[rgba(18,118,109,0.08)] to-[rgba(15,93,86,0.04)] border-[rgba(18,118,109,0.25)] dark:from-[rgba(18,118,109,0.12)] dark:to-[rgba(15,93,86,0.06)] dark:border-[rgba(18,118,109,0.35)] max-md:p-4 max-md:rounded-xl">
      <div className="mb-5 pb-5 border-b-2 border-[rgba(18,118,109,0.15)] dark:border-[var(--border-color)] max-md:mb-4 max-md:pb-4">
        <h3 className="m-0 mb-3 text-base font-semibold text-[var(--text-primary)] max-md:text-[15px] max-md:mb-2.5">
          Full Sentence
        </h3>
        <div className="flex items-center gap-4 max-md:flex-col max-md:items-start max-md:gap-3">
          <p className="flex-1 m-0 text-base font-medium leading-relaxed text-[var(--text-primary)] max-md:text-[15px] max-md:w-full">
            {textToRead}
          </p>
          <button
            type="button"
            className={`pronunciation-play-button ${playBtnBase} ${isLoadingFullSentence ? playBtnLoading : ''}`}
            onClick={onPlayFullSentence}
            aria-label={isLoadingFullSentence ? 'Loading pronunciation audio' : 'Play full sentence'}
            aria-busy={isLoadingFullSentence}
          >
            {isLoadingFullSentence ? (
              <span className="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" />
            ) : (
              <SpeakerHigh size={24} weight={isPlayingFullSentence ? 'fill' : 'regular'} />
            )}
          </button>
        </div>
      </div>

      <div>
        <h3 className="m-0 mb-3 text-base font-semibold text-[var(--text-primary)] max-md:text-[15px] max-md:mb-2.5">
          Word Analysis
        </h3>
        <div className="flex flex-col gap-3 max-md:gap-2.5">
          {wordDetails.map((wordDetail, index) => {
            const score =
              wordDetail['accuracy-score'] !== undefined && wordDetail['accuracy-score'] !== null
                ? Math.floor(wordDetail['accuracy-score'])
                : 0;
            const isGood = score > 74;
            const isWordLoading = loadingWordIndex === index;

            return (
              <div
                key={index}
                className="flex items-center gap-4 p-4 rounded-xl bg-[var(--card-bg)] dark:bg-[var(--bg-tertiary)] border-2 border-transparent transition-all duration-300 hover:border-[rgba(18,118,109,0.2)] hover:shadow-[0_2px_8px_rgba(18,118,109,0.1)] dark:hover:border-[rgba(18,118,109,0.3)] max-md:p-3 max-md:gap-3 max-md:flex-wrap"
              >
                <button
                  type="button"
                  className={`word-play-button ${playBtnBase} ${isWordLoading ? playBtnLoading : ''} max-md:min-w-[44px] max-md:min-h-[44px] max-md:p-2.5`}
                  onClick={() => onPlayWord(wordDetail.word, index)}
                  aria-label={`Play word: ${wordDetail.word}`}
                  aria-busy={isWordLoading}
                >
                  {isWordLoading ? (
                    <span className="w-[18px] h-[18px] border-2 border-white/40 border-t-white rounded-full animate-spin" />
                  ) : (
                    <SpeakerHigh size={20} weight={playingWordIndex === index ? 'fill' : 'regular'} />
                  )}
                </button>
                <span className="flex-1 text-lg font-semibold text-[var(--text-primary)] max-md:text-base max-md:min-w-0">
                  {wordDetail.word}
                </span>
                <span
                  className={`text-sm font-semibold py-1.5 px-3 rounded-md min-w-[50px] text-center border-2 max-md:text-[13px] max-md:py-1 max-md:px-2.5 max-md:min-w-[45px] ${
                    isGood
                      ? 'bg-emerald-100 dark:bg-emerald-500/15 text-emerald-800 dark:text-emerald-400 border-emerald-500 dark:border-emerald-500/40'
                      : 'bg-red-100 dark:bg-red-500/15 text-red-800 dark:text-red-400 border-red-500 dark:border-red-500/40'
                  }`}
                >
                  {score}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WordAnalysis;
